import { useEffect, useRef, useState } from "react";
import {
  getQueryParam,
  trimValue,
  convertDateToJson,
  isInCompliance,
  isUSCompliance,
  isBenefitEnabled,
  isIndiaCompliance,
  getTenantCountryCode,
  getCountryPhoneCode,
  showUserLimitExceedsAlert,
} from "../../managers/common/CommonUtil";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import Stepper from "../common/Stepper";
import EmployeeStepManager from "./EmployeeStepManager";
import {
  showToast,
  TOAST_TYPE,
  DKButton,
  showLoader,
  removeLoader,
  showAlert,
  isValidEmail
} from "deskera-ui-library";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchEmployeeMeta,
  fetchHolidays,
  selectEmployeeMeta,
  selectHolidays,
  fetchTenantData,
  selectTenanatData,
  fetchEmployeeDetails,
  selectEmployeeData,
  fetchEmployeeTaxDetails,
  deleteEmployeeDetails,
  updateEmployeeDetails,
  fetchBankDetails,
  fetchCPFAccount,
  fetchEmployeeListWithoutFilter,
  selectEmployeeListWithoutLimit,
} from "../../Redux/Slices/EmployeeListSlice";
import {
  fetchTotalComponents,
  selectComponent,
} from "../../Redux/Slices/ComponentListSlice";
import {
  fetchTotalBenefits,
  selectBenefits,
} from "../../Redux/Slices/BenefitSlice";
import Utility, { deepClone, setReactRef } from "../../utility/Utility";
import {
  CONFIG_SECTION,
  getReportingManagerOptions,
  PaymentMethods,
} from "./steps/Employee";
import moment from "moment";
import Table from "../../services/table";
import {
  fetchCustomFields,
  selectCustomField,
} from "../../Redux/Slices/CustomFieldsSlice";
import CustomFieldService from "../../services/CustomFieldService";
import {
  ARF,
  CASHFREE_STATUS_MAP,
  COLUMN_CODES,
  CONSTANTS,
  COUNTRY_CODE,
  ERF,
  EXEMPT_FIELDS_FROM_INITIALS,
  INPUT_FIELD_MAP,
  INPUT_FIELD_MAP_COMPLIANCE,
  INPUT_TYPE,
  PAYMENT_MAP,
} from "../../constants/Constant";
import EmployeeListService from "../../services/EmployeeListService";
import { COMPONENT_FREQUENCY_TYPE_LIST } from "../Component/ComponentConstants";
import TenantManager from "../../managers/TenantManager";
import ApiConstants from "../../constants/ApiConstants";
import { useTranslation } from "react-i18next";
import { TENANT, TenantService } from "../../managers/TenantManagerService";
import { COMPLIANCE_COUNTRIES, COUNTRY } from "../../constants/CountryConstant";
import { fetchLocationList } from "../../Redux/Slices/LocationListSlice";
import i18next from "i18next";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";
import { Store } from "../../Redux/Store";
import { fetchTeams } from "../../Redux/Slices/PayrollSlice";
import CustomSectionManager from "../../managers/CustomSectionManager";

let autoSaveTimer;

const AddEmployeePortal = (props) => {
  const { t, i18n } = useTranslation();
  const customFieldSectionEnabled = TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED);

  const initialState = {
    incompleteData: [],
    rowData: [],
    originalData: [],
    filter: [],
    defaults: [],
    columnConfig: {},
  };

  /**** GLobal variables *****/
  // const tableName = getQueryParam(props.location, "module");
  // const source = getQueryParam(props.location, "origin");
  let selectedUser = getQueryParam(props.location, "id");
  const passedStep = getQueryParam(props.location, "step");
  const isEdit = getQueryParam(props.location, "isEdit") === "true";
  const stepperWidth = 200;

  /**Hooks */

  const [currentStep, setCurrentStep] = useState(parseInt(passedStep));
  const [requiredParams, setRequiredProps] = useState(deepClone(initialState));
  const [steps, setSteps] = useState([]);
  const [employeeResponse, setSelectedEmployeeData] = useState({});
  const [userId, setUserId] = useState(selectedUser);
  const [isEditState, setEditState] = useState(isEdit);
  const [reportingManagerOptions, setReportingManagerOptions] = useState(null);

  /**Selectors */
  const dispatch = useDispatch();
  const holidays = useSelector(selectHolidays);
  const totalComponent = useSelector(selectComponent);
  const totalBenefits = useSelector(selectBenefits);
  const employeeMeta = useSelector(selectEmployeeMeta);
  const tenantData = useSelector(selectTenanatData);
  const customFields = useSelector(selectCustomField);
  const employeeDetails = useSelector(selectEmployeeData);
  const allEmployees = useSelector(selectEmployeeListWithoutLimit);
  const [previousPayload, setPreviousPayload] = useState(undefined);

  const [isDuplicateEmpId, setIsDuplicateEmpId] = useState(false);
  const [userDataUpdated, setUserDataUpdated] = useState(false);

  //ref
  const childRef = useRef();
  const latestRequiredParams = useRef(requiredParams);

  if (!TenantService.get(TENANT.IS_ADMIN)) {
      setReactRef(ERF.ADD_EMPLOYEE);
  } else if (TenantService.get(TENANT.IS_ADMIN) && isEdit) {
      setReactRef(ARF.ADD_EMPLOYEE);
  }

  useEffect(() => {
    RouteManager.setPresenter({ props: props });
    if(Utility.isEmpty(userId) && Utility.isEmpty(passedStep)) {
      RouteManager.navigateToPage(PAGE_ROUTES.EMPLOYEE_LIST);
    }
    // showLoader();
    if (!userId && isEdit) {
      RouteManager.navigateToPage(PAGE_ROUTES.EMPLOYEE_LIST);
    } else if (isEdit && !Utility.isEmpty(userId)) {
      showLoader();
      loadEmployeeDetails(userId);
      let params = {
        countryCode: COUNTRY_CODE.INDIA,
        userIds: [userId],
      };
      if(isIndiaCompliance()) {
        loadEmployeeTaxes(params);
      }
    }

    EmployeeListService.employeeStepperCurrentStep = 0;

    loadHolidays({});
    loadComponents({});
    loadBenefits({});
    loadEmployeeMeta({});
    loadTenantData({});
    loadCustomFields({});
    loadLocationsDetails({});

    if (!customFieldSectionEnabled) {
      loadAllEmployees({
        customJson: {
          "orderBy.field": "updatedAt",
          "orderBy.order": "desc",
        },
      });
    }

    if (getTenantCountryCode() === COUNTRY.SG || getTenantCountryCode() === COUNTRY.MY ) {
      loadTenantBankDetails(getTenantCountryCode());
      loadCPFAccountDetails();
    }

  }, []);

  useEffect(() => {
    const steps = EmployeeStepManager.getAllCreationSteps(onStepClick);
    steps.forEach((step) => {
        step.title = t(step.title);
    });
    setSteps(steps);
    if (!Utility.isEmpty(customFields)) {
      // removeLoader();
    }
  }, [employeeMeta]);

  useEffect(() => {
    if (employeeDetails.user) {
        setSelectedEmployeeData(employeeDetails.user);
    }
  }, [employeeDetails])

  useEffect(() => {
    if (!customFieldSectionEnabled && Array.isArray(allEmployees.users)) {
      const options = getReportingManagerOptions(allEmployees, userId, true);
      setReportingManagerOptions(options);
    }
  }, [allEmployees]);

  useEffect(() => {
    return () => {
      clearAutoSaveTimer();
      EmployeeListService.employeeStepperCurrentStep = 0;
      removeEmployeeDetails();
    }
  }, []);

  const loadHolidays = async (config) => {
    try {
      await dispatch(fetchHolidays());
    } catch (err) {
      console.error("Error loading holidays: ", err);
    }
  };

  const loadComponents = async (config) => {
    try {
      await dispatch(fetchTotalComponents());
    } catch (err) {
      console.error("Error loading components: ", err);
    }
  };

  const loadBenefits = async (config) => {
    try {
      await dispatch(fetchTotalBenefits());
    } catch (err) {
      console.error("Error loading benefits: ", err);
    }
  };

  const loadEmployeeMeta = async (config) => {
    try {
      const { tenant } = TenantManager.getPeopleTenantData();
      const countryCode = tenant && tenant.countryCode ? tenant.countryCode : "";
      if (COMPLIANCE_COUNTRIES.includes(countryCode)) {
          await dispatch(fetchEmployeeMeta(countryCode));
      }
    } catch (err) {
      console.error("Error loading employee meta: ", err);
    }
  };

  const loadTenantData = async (config) => {
    try {
      await dispatch(fetchTenantData());
    } catch (err) {
      console.error("Error loading organization data: ", err);
    }
  };

  const loadCustomFields = async (config) => {
    try {
      config = {
        ...CustomFieldService.apiConfig,
        Module: "employee_details",
      };
      CustomFieldService.apiConfig = config;
      await dispatch(fetchCustomFields());
    } catch (err) {
      console.error("Error loading custom fields data: ", err);
    }
  };

  const loadEmployeeDetails = async (userId) => {
    try {
      const config = {
        ...EmployeeListService.apiConfig,
        getComponents: true,
        getCompliance: true,
        getBenefits: true,
        customFieldModule: "employee",
      };
      EmployeeListService.apiConfig = config;
      await dispatch(fetchEmployeeDetails(userId));

    } catch (err) {
      removeLoader();
      console.error("Error loading employee details: ", err);
    }
  };

  const loadAllEmployees = async (config) => {
    try {
        EmployeeListService.apiConfig = config;
        await dispatch(fetchEmployeeListWithoutFilter());
    } catch (err) {
        console.error('Error loading employees: ', err);
    }
};

  const loadEmployeeTaxes = async (parameter) => {
    try {
      await dispatch(fetchEmployeeTaxDetails(parameter));
    } catch (err) {
      removeLoader();
      console.error("Error loading employee tax details: ", err);
    }
  };

  const loadLocationsDetails = async () => {
    try {
      await dispatch(fetchLocationList());
    } catch (err) {
      console.error("Error loading custom fields data: ", err);
    }
  };
  const loadTenantBankDetails = async (countryCode) => {
    try {
      await dispatch(fetchBankDetails(countryCode));
    } catch (err) {
      console.error("Error loading custom fields data: ", err);
    }
  }



  const loadCPFAccountDetails = async () => {
    try {
      const config = {
        Limit: 100,
        currentPage: 1,
        order: undefined,
        field: undefined,
        searchString: undefined,
      };
      EmployeeListService.apiConfig = config;
      await dispatch(fetchCPFAccount());
    } catch (err) {
      console.error("Error loading custom fields data: ", err);
    }
  };


    useEffect(() => {
        if (requiredParams.isAutoSave) {
            clearAutoSaveTimer();
            autoSaveTimer = setTimeout(() => {
                const newPayload = prepareDataForEmployeeForm();
                if (isPayloadChanged(previousPayload, deepClone(newPayload)) && (!isEditState || employeeDetails?.user?.status === CONSTANTS.DRAFT || employeeDetails?.user?.isInCompleteProfile)) {
                    saveAsDraft(newPayload, true);
                }
            }, ApiConstants.AUTOSAVE_INTERVAL);
        }

        if (requiredParams.isStepClick && currentStep !== requiredParams.stepIndex && employeeDetails?.user?.status !== CONSTANTS.DRAFT) {
            onSkipToStep(null, requiredParams.stepIndex, currentStep > requiredParams.stepIndex, false, true);
        }
    }, [requiredParams]);

    const clearAutoSaveTimer = () => {
        clearTimeout(autoSaveTimer);
    }

    const isPayloadChanged = (previousPayload, newPayload) => {
        if (!previousPayload || Object.keys(previousPayload).length !== Object.keys(newPayload).length) {
            return true;
        }

        for (let key of Object.keys(newPayload)) {
            switch (key) {
                case "dateOfBirth":
                case "dateOfJoining":
                case "dateOfConfirmation":
                    const previousDate = previousPayload[key];
                    const newDate = newPayload[key];
                    if (previousDate?.substring(0, previousDate?.indexOf("T")) !== newDate?.substring(0, newDate?.indexOf("T"))) {
                        return true;
                    }
                    break;
                case "ctc":
                    if (String(previousPayload[key]) !== String(newPayload[key])) {
                        return true;
                    }
                    break;
                default:
                    if (Array.isArray(newPayload[key])) {
                        if (key === "customFieldData" && newPayload[key]?.length > 0 && previousPayload[key]?.length > 0 ) {
                            let isChanged = false;
                            newPayload[key].forEach((nd) => {
                                previousPayload[key].forEach((od) => {
                                    if (nd.customFieldId === od.customFieldId && JSON.stringify(nd.value) !== JSON.stringify(od.value)) {
                                        isChanged = true;
                                    }
                                });
                            });

                            if (isChanged) {
                                return true;
                            }
                        } else {
                            if (JSON.stringify(previousPayload[key]) !== JSON.stringify(newPayload[key])) {
                                return true;
                            }
                        }
                    } else if (typeof newPayload[key] === "object") {
                        if (isPayloadChanged(previousPayload[key], deepClone(newPayload[key]))) {
                            return true;
                        }
                    } else {
                        if (previousPayload[key] !== newPayload[key]) {
                            return true;
                        }
                    }
                    break;
            }
        }

        return false;
    }

    const saveAsDraft = (payload, isAutoSave) => {
        let params;
        if(!isEdit && requiredParams['defaults'] && ((Utility.isEmpty(requiredParams['defaults']['employeeId']) &&  Utility.isEmpty(requiredParams['defaults']['documentSequenceId']))||(!requiredParams['employeeIdValid'])) ) {
          showToast(i18next.t("EMPLOYEE_ID_EXIST"), TOAST_TYPE.FAILURE);
          return true;
        }
        // Add case for Employee Id error in Draft created user
        if(isEdit && requiredParams['columnConfig'] && requiredParams['columnConfig']['detailsConfig']) {
          let employeeIdColumn = requiredParams['columnConfig']['detailsConfig'].find(field=>field.columnCode==='employeeId')
          if(employeeIdColumn.hasError) {
            showToast(i18next.t("EMPLOYEE_ID_EXIST"), TOAST_TYPE.FAILURE);
            return;
          }
        }

        // Check for invalid email
        if(!isEdit && requiredParams['columnConfig'] && requiredParams['columnConfig']['detailsConfig']) {
            const emailId = requiredParams['columnConfig']['detailsConfig'].find(f => f.columnCode === 'emailId');
            if(emailId.hasError || !isValidEmail(requiredParams['defaults']['emailId'])) {
                showToast("Please enter valid emailId", TOAST_TYPE.FAILURE);
                return;
            }
        }

        if (payload) {
            params = payload;
        } else {
            params = prepareDataForEmployeeForm();
        }

        setPreviousPayload(deepClone(params));
        if(Utility.isEmpty(params['documentSequenceId']) && (!params["employeeId"] || Utility.isEmpty(params['employeeId']))) {
          showToast(i18next.t("VALID_EMP_ID_MSG"), TOAST_TYPE.FAILURE);
          return true
        }
        if (isEditState) {
            params["status"] = employeeDetails?.user?.status || CONSTANTS.DRAFT;
        } else {
          params["status"] = CONSTANTS.DRAFT;
        }

        params["hasComponents"] = false;
        params["hasCompliance"] = false;

        if (isInCompliance(getValueFromTenant("countryCode"))) {
            params["ctc"] = params.ctc || "0";
            params["compensation"] = "0";
        } else {
            params["compensation"] = params.compensation || "0";
        }

        if (isEditState) {
            params["userId"] = userId;
        }
        if (
          TenantService.get(TENANT.CUSTOM_FIELD_SECTION_ENABLED) &&
          TenantService.get(TENANT.PROGRESS_EMPLOYEE_PROFILE_SAVE_BTN)
        ) {
          params["isDraft"] = true;
        }

        if (!isAutoSave) {
            showLoader("Saving User... Please wait");
        }

        (!isEditState ? Table.saveEmployee(params) : Table.updateEmployee(params)).then(
            (response) => {
                removeLoader();
                if (response) {
                    setSelectedEmployeeData(response.user);
                    setUserId(response?.user?.userId || "");
                    setEditState(true);
                    updateEmployeeRecord(response);
                }

                if (isAutoSave) {
                    showToast("Autosaved", TOAST_TYPE.SUCCESS);
                } else {
                    showToast("Saved", TOAST_TYPE.SUCCESS);
                    RouteManager.navigateToPage(PAGE_ROUTES.EMPLOYEE_LIST);
                }
            }, (error) => {
                removeLoader();
                if (error?.message?.indexOf("user already exists with emailId/contact") !== -1) {
                    showToast("Please check for duplicate email/contact", TOAST_TYPE.FAILURE);
                } else if (error?.message === "Employee ID already exist") {
                    showToast(error.message, TOAST_TYPE.FAILURE);
                    setIsDuplicateEmpId(true);
                    childRef.current.hightlightInvalidEmployeeId();
                } else if (error?.code === 2 && typeof error?.message === "string" && error.message.includes("required fields cannot be empty:")) {
                    showToast(`${isAutoSave ? "Autosave: " : ""} Please fill all the mandatory details`, TOAST_TYPE.FAILURE);
                } else {
                    showToast("Internal server error", TOAST_TYPE.FAILURE);
                }
            }
        );
    }

    const onStepClick = (index) => {
        setRequiredProps({
            ...latestRequiredParams.current,
            isStepClick: true,
            stepIndex: index
        });
    }

  const onSkipToStep = (event, index, isBack, isSubmit, skipStepValidation) => {
    const step = currentStep;

    /* By default expected step is to move forward */
    let expectedStep
    if(isBack) {
      expectedStep = index ?? step - 1;
    } else {
      expectedStep = index ?? step + 1;
    }

    /* If it's the last step */
    if (expectedStep === steps.length) {
      // handleImportConfirmation();
      return;
    }

    if (isBack) {
        EmployeeListService.employeeStepperCurrentStep = expectedStep;
        setCurrentStep(expectedStep);
    } else if (isEdit && requiredParams.isStepClick && !userDataUpdated) {
        if ((currentStep !== 0 && skipStepValidation) || !isInvalidStep(expectedStep, skipStepValidation)) {
            EmployeeListService.employeeStepperCurrentStep = expectedStep;
            setCurrentStep(expectedStep);
        }
    } else {
      if (isInvalidStep(expectedStep, skipStepValidation)) {
        if(!isEdit && expectedStep === 1 && !requiredParams['employeeIdValid']) {
          showToast(i18next.t("EMPLOYEE_ID_EXIST"), TOAST_TYPE.FAILURE);
        } else {
          const errorInfo = steps[step].reqError || `Some of the employees have incomplete profiles. Please update their profiles to proceed.`;
          if(isEmployeeIdInvalid(expectedStep)) {
            showToast(errorInfo, TOAST_TYPE.FAILURE);
          } else {
            showToast(errorInfo, TOAST_TYPE.FAILURE);
          }
        }
        return true;
      } else {
        if (customFieldSectionEnabled && !PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.EDIT])) {
          if (currentStep === 2 && userId === TenantService.get(TENANT.USER_ID)) {
            saveFormData(currentStep, expectedStep, isSubmit);
          }
          EmployeeListService.employeeStepperCurrentStep = expectedStep;
          setCurrentStep(expectedStep);
          return;
        }
        saveFormData(currentStep, expectedStep, isSubmit);
      }
    }
  };

  const isEmployeeIdInvalid = (expectedStep)=>{
    if(expectedStep === 1 && (!isEdit) && (requiredParams) && (requiredParams['defaults']) && (Utility.isEmpty(requiredParams['defaults']['employeeId']) && (Utility.isEmpty(requiredParams['defaults']['documentSequenceId'])))){
      return true
    }
      return false


  }
  const isInvalidStep = (expectedStep, skipStepValidation) => {
    if (expectedStep < 0 || expectedStep >= steps.length) return false;

    /* Check if component has required data for expected step */
    const { requiredProps } = steps[expectedStep];
    if (expectedStep === 1 || expectedStep === 2) {
        if(!isEdit && expectedStep === 1 && (!requiredParams['employeeIdValid'])) {
          showToast(i18next.t("EMPLOYEE_ID_EXIST"), TOAST_TYPE.FAILURE);
          return true;
        }

        if(isEmployeeIdInvalid(expectedStep)) {
          return true;
        }

        return requiredProps.some((requiredProp) => requiredParams[requiredProp] && isInvalidRecordPresent(requiredParams[requiredProp], skipStepValidation));
    } else if (expectedStep === 3) {
        let invalid = false;
        if (currentStep === 0) {
          invalid = requiredProps.some(
            (requiredProp) => requiredParams[requiredProp] && isInvalidRecordPresent(requiredParams[requiredProp], skipStepValidation)
          );
        }
        if (invalid) {
          return true;
        }

        return requiredProps.some(
          (requiredProp) =>
            requiredParams[requiredProp] &&
            isInvalidRecordPresentInCompliance(requiredParams[requiredProp])
        );
    } else {
      let invalid = false;
      if (currentStep === 0) {
        invalid = requiredProps.some(
          (requiredProp) => requiredParams[requiredProp] && isInvalidRecordPresent(requiredParams[requiredProp], skipStepValidation)
        );
      }
      if (invalid) {
        return true;
      }

      return requiredProps.some(
        (requiredProp) => requiredParams[requiredProp] === null
      );
    }
  };

  const isInvalidRecordPresent = (configs, skipStepValidation) => {
    let columns = [];
    if (currentStep === 0) {
      columns.push(configs.detailsConfig);
      columns.push(configs.contactConfig);
      if (TenantService.get(TENANT.IS_ADMIN) && PermissionUtils.hasAccess(MODULE.SALARY, ACTION.EDIT)) {
          columns.push(configs.compensationConfig);
      }
      columns.push(configs.paymentConfig);
      columns.push(configs.customFields);
      columns.push(configs.billingFormFields);
    } else if (currentStep === 1) {
      // columns = configs;
      columns.push(configs.fixedComponents);
      columns.push(configs.variableComponents);
      // columns.push(configs.salaryAdvanceFields);
      let isComponentsValid = isInvalidRecordPresentInComponent(columns);
      if (hasInvalidcustomSectionField(configs)) {
        isComponentsValid = true;
        childRef.current.hightlightInvalidFields(skipStepValidation);
      }
      return isComponentsValid;
    } else {
      columns.push(configs.compliance);
    }
    let isInvalid = false;
    for (let i = 0; i < columns.length; i++) {
      let columnConfig = columns[i];
      for (let item = 0; item < columnConfig?.length; item++) {
        let individualColumn = columnConfig[item];
        const params = requiredParams["defaults"];
        if (
          !EXEMPT_FIELDS_FROM_INITIALS.includes(individualColumn.columnCode) &&
          individualColumn &&
          params &&
          ((individualColumn.required &&
          Utility.isEmpty(params[individualColumn.columnCode]) || individualColumn.hasError))
        ) {
          isInvalid = true;
          childRef.current.hightlightInvalidFields(skipStepValidation);
          return isInvalid;
        } else {
          switch(individualColumn.columnCode) {

          case 'dateOfConfirmation':
            let doj = params["dateOfJoining"];
            let doc = params["dateOfConfirmation"];
            if (!Utility.isEmpty(doj) && !Utility.isEmpty(doc)) {
                doj = moment(params["dateOfJoining"]);
                doc = moment(params["dateOfConfirmation"]);

                if (doj.diff(doc) > 0) {
                    isInvalid = true;
                    childRef.current.hightlightInvalidFields(skipStepValidation);
                    return isInvalid;
                }
            }
            break;
          case COLUMN_CODES.PASSPORT_NUMBER:
              let passportNo = params[COLUMN_CODES.PASSPORT_NUMBER]
              let passortCountry = params[COLUMN_CODES.PASSPORT_COUNTRY]
              if(!Utility.isEmpty(passportNo) && Utility.isEmpty(passortCountry)) {
                isInvalid = true;
                return isInvalid
              }
              break;
            case COLUMN_CODES.CTC:
              let ctc = parseFloat(params[COLUMN_CODES.CTC]);
              if ((isNaN(parseFloat(ctc)) && tenantData.tenant['customSectionFieldsEnabled']) || (ctc !== -1 && typeof ctc === "number" && Utility.isEmpty(ctc) && !tenantData.tenant['customSectionFieldsEnabled'])) {
                isInvalid = true;
                childRef.current.hightlightInvalidFields(skipStepValidation);
                return isInvalid;
              }
              break;
            case COLUMN_CODES.DEFAULT_COMPENSATION:
              let defaultCompensation = parseFloat(params[COLUMN_CODES.DEFAULT_COMPENSATION]);
              if ((isNaN(parseFloat(defaultCompensation)) && tenantData.tenant['customSectionFieldsEnabled']) || (typeof defaultCompensation === "number" && Utility.isEmpty(defaultCompensation)) && !tenantData.tenant['customSectionFieldsEnabled']) {
                isInvalid = true;
                childRef.current.hightlightInvalidFields(skipStepValidation);
                return isInvalid;
              }
              break;
              case COLUMN_CODES.EMPLOYEEID:
                  if (isEdit && individualColumn.required && individualColumn.hasError) {
                      return true
                  } else {
                      if (
                          individualColumn.required &&
                          Utility.isEmpty(params[individualColumn.columnCode]) &&
                          Utility.isEmpty(params["documentSequenceId"])
                      ) {
                          isInvalid = true;
                          childRef.current.hightlightInvalidFields(skipStepValidation);
                          return isInvalid;
                      }
                  }
                  break;
              case COLUMN_CODES.DATE_OF_BIRTH:
                  let invalidDob = checkValidation(individualColumn, params);
                  if (invalidDob) {
                    isInvalid = true;
                    childRef.current.hightlightInvalidFields(skipStepValidation);
                    return isInvalid;
                  }
          }

        }
      }
    }

    if (currentStep === 0) {
        configs?.contactConfig?.forEach((field) => {
            const error = hasError(field, field.value);
            field.invalid = error.invalid;
            field.errorMsg = error.errorMsg;

            if (field.invalid) {
                isInvalid = true;
                childRef.current.hightlightInvalidFields(skipStepValidation);
            }
        });
    }

    if (!(currentStep === 0 && skipStepValidation)) {
      if (hasInvalidcustomSectionField(configs)) {
        isInvalid = true;
        childRef.current.hightlightInvalidFields(skipStepValidation);
      }
    }

    return isInvalid;
  };

  const checkValidation = (column, params) => {
        let invalid = false;
        const validation = column.validation;
        validation.forEach((v) => {
            switch (v) {
                case "greaterThan":
                    let field = moment(params[column.greaterThanField[0]]);
                    let doc = moment(params["dateOfConfirmation"]);

                    if (field.diff(doc) <= 0) {
                        invalid = false;
                    } else {
                        invalid = true;
                    }
                    break;
                case "lessThan":
                    let field1 = moment(params[column.lessThanField[0]]);
                    let dob = moment(params["dateOfBirth"]);
                    if (!Utility.isEmpty(field1) && moment(dob).isSameOrAfter(field1)) {
                        invalid = true;

                    } else {
                        invalid = false;
                    }
            }
        });
        return invalid;
    }

  const hasError = (field, value) => {
    let error = {
        invalid: false,
        errorMsg: null
    };

    const validation = field.validation;

    if (validation && validation.length !== 0) {
        validation.forEach((validation) => {
            switch (validation[0]) {
                case "required":
                    if (value === null || value === undefined || String(value).trim() === "") {
                        error.invalid = true;
                    }
                    break;
                case "pattern":
                    if (value && !new RegExp(validation[1]).test(value)) {
                        error.invalid = true;
                        error.errorMsg = "Invalid " + field.title;
                    }
                    break;
            }
        });
    }

    return error;
  }

  const verifyIfscAccountNumber = (values, employeeDataObject, expectedStep) => {
    const ifsc = values['ifsc'];
    const accNumber = values["accountNumber"];

    let paramerts = {
      name: `${values["firstName"]}`,
      phone: values["contact"] ? `${getCountryPhoneCode()}${values["contact"]}` : "",
      bankAccount: accNumber ? accNumber : "",
      ifsc: ifsc ? ifsc : "",
    };
    showLoader("Verifying account number and ifsc code...Please wait");
    Table.verifyIfscAccountNumber(paramerts).then((res) => {
      const responseMessage = res.message ? res.message : "";
      if (responseMessage) {
        if (responseMessage.includes(CONSTANTS.INVALID) || CASHFREE_STATUS_MAP[responseMessage] === "FAILURE") {
          showToast(
            `${"Invalid Account Number or IFSC provided"}`,
            TOAST_TYPE.FAILURE
          );
        } else {
          saveEmployeeData(employeeDataObject, expectedStep);
        }
      } else {
        saveEmployeeData(employeeDataObject, expectedStep);
      }
      removeLoader();
    },
    (err) => {
      saveEmployeeData(employeeDataObject, expectedStep);
      // removeLoader();
    })
  }

  const isInvalidRecordPresentInComponent = (columns) => {
    let isInvalid = false;
    for (let i = 0; i < columns.length; i++) {
      let columnConfig = columns[i];
      for (let item = 0; item < columnConfig?.length; item++) {
      let individualColumn = columnConfig[item];
      const params = requiredParams["defaults"];
      if (
        individualColumn &&
        params &&
        (individualColumn.hasError ||
          individualColumn.hasErrorAmount ||
          individualColumn.hasErrorVariable)
      ) {
        isInvalid = true;
        return isInvalid;
      }
    }
    }
    return isInvalid;
  };

  const isPreviousStepSelected = (expectedStep, currentSelectedStep) => {
    if (expectedStep != steps.length && expectedStep < currentSelectedStep) {
      return true;
    } else {
      return false;
    }
  }


  const saveFormData = (step, expectedStep) => {
    let employeeDataObject = {};
    let isBackTrack = isPreviousStepSelected(expectedStep, EmployeeListService.employeeStepperCurrentStep);
    if (isBackTrack) {
      setCurrentStep(expectedStep);
      EmployeeListService.employeeStepperCurrentStep = expectedStep;
    } else {
      switch (step) {
        case 0:
          const employeeFormData = prepareDataForEmployeeForm();
          employeeDataObject = Object.assign(employeeFormData);
          employeeDataObject["hasComponents"] = false;
          employeeDataObject["hasCompliance"] = false;
          if (isEditState) {
            employeeDataObject["userId"] = userId;
          } else {
            employeeDataObject["makePayroll"] = true;
          }

          if (employeeDetails?.user?.status === CONSTANTS.DRAFT) {
              employeeDataObject["status"] = CONSTANTS.SUBMIT;
          }

          const params = requiredParams["defaults"];
          let isCashfreeEnabled = getValueFromTenant("isCashfreeEnabled");
          if(Utility.isEmpty(employeeFormData['documentSequenceId'] )&& (!employeeFormData["employeeId"] || Utility.isEmpty(employeeFormData['employeeId']))) {
            showToast(i18next.t("VALID_EMP_ID_MSG"), TOAST_TYPE.FAILURE);
            return true
          }
          let isInvalid = isBankVerificationAllowed(isCashfreeEnabled, params)
            ? verifyIfscAccountNumber(params, employeeDataObject, expectedStep)
            : saveEmployeeData(employeeDataObject, expectedStep);;
          break;
        case 1:
          const componentFormData = getComponentDetailsDataObject();
          employeeDataObject = Object.assign(componentFormData);
          employeeDataObject["hasComponents"] = true;
          employeeDataObject["hasCompliance"] = false;
          employeeDataObject["userId"] = userId;

          if (isBenefitEnabled()) {
            const benefitFormData = getBenefitsDetailsDataObject();
            employeeDataObject["hasBenefits"] = true;
            employeeDataObject["benefits"] = benefitFormData;
          }

          if (requiredParams["defaults"] && requiredParams["defaults"].customSectionFields) {
            employeeDataObject["customSectionFields"] = CustomSectionManager.getCustomSectionFieldValues(requiredParams["defaults"].customSectionFields);
          }
          saveEmployeeData(employeeDataObject, expectedStep);
          // setCurrentStep(expectedStep);
          break;
        case 2:
            if (COMPLIANCE_COUNTRIES.includes(getTenantCountryCode())) {
                const complianceFormData = prepareDataForCompliance();
                if (complianceFormData) {
                  employeeDataObject["hasComponents"] = false;
                  employeeDataObject["countryCode"] =
                    getValueFromTenant("countryCode");
                  employeeDataObject["userId"] = userId;
                  employeeDataObject["hasCompliance"] = true;
                  employeeDataObject["compliance"] = complianceFormData;
                }

                if (requiredParams["defaults"] && requiredParams["defaults"].customSectionFields) {
                  employeeDataObject["customSectionFields"] = CustomSectionManager.getCustomSectionFieldValues(requiredParams["defaults"].customSectionFields);
                }
                saveEmployeeData(employeeDataObject, expectedStep);
            } else {
                employeeDataObject = {
                    userId: userId,
                    hasDocuments: true,
                    documents: requiredParams["defaults"]["documents"] || []
                };
    
                if (requiredParams["defaults"] && requiredParams["defaults"].customSectionFields) {
                  employeeDataObject["customSectionFields"] = CustomSectionManager.getCustomSectionFieldValues(requiredParams["defaults"].customSectionFields);
                }
                saveEmployeeData(employeeDataObject, expectedStep);
            }
          break;
        case 3:
            employeeDataObject = {
                userId: userId,
                hasDocuments: true,
                documents: requiredParams["defaults"]["documents"] || []
            };

            saveEmployeeData(employeeDataObject, expectedStep);
            break;
      }
    }
  };

  const isBankVerificationAllowed = (isCashfreeEnabled, params) => {
    let isAllowed = false;
    try{
      let paymentMethod = getSelectedIdFromDropDown(
        params.paymentMethod,
        PaymentMethods,
        "id"
      );
      if (
        isCashfreeEnabled &&
        PAYMENT_MAP[paymentMethod] === CONSTANTS.DIRECT_DEPOSIT
      ) {
        isAllowed = true;
      } else {
        isAllowed = false;
      }
      return isAllowed;
    } catch(err) {
      return isAllowed;
    }
  }

  const prepareDataForEmployeeForm = () => {
    let effectiveCompensations = [];
    const params = requiredParams["defaults"];

    const paymentMethod = EmployeeListService.getSelectedIdFromObject(
      params.paymentMethod,
      "id"
    );
    let paymentJson = {};
    paymentJson = {
      paymentMethod: paymentMethod,
      accountType: EmployeeListService.getSelectedIdFromObject(
        params.accountType,
        "id"
      ),
      routingNumber:
        paymentMethod === "directDeposit" && params.routingNumber
          ? params.routingNumber.toString()
          : CONSTANTS.EMPTY_STRING,
      accountNumber:
        paymentMethod != "upi" && params.accountNumber
          ? params.accountNumber.toString()
          : CONSTANTS.EMPTY_STRING,
      bank: CONSTANTS.EMPTY_STRING,
      bankId: CONSTANTS.EMPTY_STRING,
      upi:
        paymentMethod === "upi" && params.upiId
          ? params.upiId.toString()
          : CONSTANTS.EMPTY_STRING,
      ifsc: params.ifsc ? params.ifsc.toString() : CONSTANTS.EMPTY_STRING,
    };

    if((getTenantCountryCode() === COUNTRY.MY || getTenantCountryCode() === COUNTRY.SG) && paymentMethod === "directDeposit") {
      paymentJson["bank"] = EmployeeListService.getSelectedIdFromObject(params.bank, "key");
      paymentJson["bankId"] = EmployeeListService.getSelectedIdFromObject(params.bank, "id");
      paymentJson["accountType"] = EmployeeListService.getSelectedIdFromObject(params.bank, "id");
    }

    const employeeDetailsDataObject = {
      firstName: trimValue(params.firstName),
      lastName: trimValue(params.lastName),
      name: trimValue(params.firstName) + " " + trimValue(params.lastName),
      employeeId: params.employeeId,
      documentSequenceId: params.documentSequenceId,
      aliasName: params.aliasName ? params.aliasName : CONSTANTS.EMPTY_STRING,
      designation: params.designation,
      emailId: params.emailId,
      contact: params.contact ? `${getCountryPhoneCode()}${params.contact}` : CONSTANTS.EMPTY_STRING,
      gender: params.gender ? EmployeeListService.getSelectedIdFromObject(params.gender, "id") : CONSTANTS.EMPTY_STRING,
      employeeType: params.employeeType
        ? parseInt(EmployeeListService.getSelectedIdFromObject(params.employeeType, "id"))
        : 0,
      organizationName: getValueFromTenant("organizationName"),
      countryCode: getValueFromTenant("countryCode"),
      compensation: params.ctc,
      compensationCurrency: getValueFromTenant("currency"),
      compensationPeriod: EmployeeListService.mapDropdownIdToCompensationPeriod(EmployeeListService.getSelectedIdFromObject(params.period, "id")),
      dateOfBirth: params.dateOfBirth ? convertDateToJson(params.dateOfBirth) : CONSTANTS.EMPTY_STRING,
      maritalStatus: EmployeeListService.getSelectedIdFromObject(params.maritalStatus, "id"),
      passportNumber: params.passportNumber ? params.passportNumber : CONSTANTS.EMPTY_STRING,
      passportCountry: EmployeeListService.getSelectedIdFromObject(params.passportCountry, "code"),
      dateOfJoining: params.dateOfJoining ? convertDateToJson(params.dateOfJoining) : CONSTANTS.EMPTY_STRING,
      dateOfConfirmation: params.dateOfConfirmation ? convertDateToJson(params.dateOfConfirmation) : isUSCompliance() ? convertDateToJson(params.dateOfJoining) : CONSTANTS.EMPTY_STRING,
      address: params.address,
      paymentDetails: paymentJson,
      ratePerHour: !Utility.isEmpty(params.ratePerHour) ? parseFloat(params.ratePerHour, 10) : 0,
      hourlyWageDefaultHrs: parseFloat(params.hourlyWageDefaultHrs),
      customSectionFields: CustomSectionManager.getCustomSectionFieldValues(params.customSectionFields)
    };

    if (customFieldSectionEnabled) {
      employeeDetailsDataObject.reportingManagerName = params.reportingManagerName;
    } else {
      employeeDetailsDataObject.reportingManagerId = EmployeeListService.getSelectedIdFromObject(params.reportingManagerId, "id");
    }

    employeeDetailsDataObject["isEffectiveSalary"] = params.isEffectiveSalary
      ? params.isEffectiveSalary
      : false;
    effectiveCompensations = params.effectiveCompensations ? params.effectiveCompensations : [];
    if (params.isEffectiveSalary) {
      effectiveCompensations.forEach((element) => {
        element.isVisible = false;
      });
      let effectiveObj = {
        compensation:
          params && params.defaultCompensation
            ? Utility.isEmpty(params.defaultCompensation) ? "0" :  params.defaultCompensation
            : "0",
        period:
          params && params.effectivePeriod
            ? EmployeeListService.mapDropdownIdToCompensationPeriod(
                EmployeeListService.getSelectedIdFromObject(
                  params.effectivePeriod,
                  "id"
                )
              )
            : CONSTANTS.EMPTY_STRING,
        effectiveDate:
          params && !Utility.isEmpty(params.effectiveDate)
            ? moment(params.effectiveDate).format("YYYY-MM-DD")
            : CONSTANTS.EMPTY_STRING,
        effectiveDefaultHrs:
          params && params.effectiveDefaultHrs
            ? Utility.isEmpty(params.effectiveDefaultHrs) ? "0" : params.effectiveDefaultHrs
            : "0",
        isVisible: true,
      };
      effectiveCompensations.push(effectiveObj);
      employeeDetailsDataObject["effectiveCompensations"] =
        effectiveCompensations;
    } else {
      employeeDetailsDataObject["effectiveCompensations"] =
        effectiveCompensations;
    }
    if (isInCompliance(getValueFromTenant("countryCode"))) {
      employeeDetailsDataObject["ctc"] = params.ctc || "0";
      employeeDetailsDataObject["compensation"] = 0;
    } else {
        employeeDetailsDataObject["ctc"] = "0";
        employeeDetailsDataObject["compensation"] = params.ctc || "0";
    }
    let customFieldsData = getCustomFieldValues(params);
    employeeDetailsDataObject["customFieldData"] = customFieldsData;
    employeeDetailsDataObject["inviteUserToFillInfo"] =
      requiredParams["isInviteFlowEnabled"];
    if (getLocationValueFromTenantDetails()) {
      employeeDetailsDataObject["locationValue"] =
        params && params.locationValue
        ? EmployeeListService.getSelectedIdFromObject(
            params.locationValue,
            "id"
          )
        : CONSTANTS.EMPTY_STRING;
    }
    return employeeDetailsDataObject;
  };

  const getComponentDetailsDataObject = () => {
    const employeeRecord = deepClone(employeeResponse);
    const params = requiredParams["defaults"];
    const columnConfig = requiredParams["columnConfig"];
    const fixedComponents = columnConfig["fixedComponents"];
    const variableComponents = columnConfig["variableComponents"];
    const componentGroup = columnConfig["selectComponentGroup"];

    const componentDetailsDataObject = {
      hasComponents: true,
    };
    componentDetailsDataObject["components"] = [];
    let fixedAssignedComponents = [];
    let deletedComponents = [];
    if (fixedComponents.length > 0) {
      if (isEditState) {
        const employeeComponents = [...fixedComponents];
        if (
          employeeRecord["components"] &&
          employeeRecord["components"].length > 0
        ) {
          employeeRecord["components"].forEach((previousComponent) => {
            let filteredComponent = totalComponent.components.find(
              (x) => x.id === previousComponent.componentId
            );
            if (filteredComponent && !filteredComponent.isVariable) {
              let currentComponent = employeeComponents.find(
                (assignedComponent) =>
                  assignedComponent["id"] === previousComponent["componentId"]
              );
              if (currentComponent) {
                if (
                  params[currentComponent.id]["amount"] !==
                  previousComponent["amount"]
                ) {
                  currentComponent["status"] = CONSTANTS.UPDATED;
                } else {
                  currentComponent["status"] = CONSTANTS.UPDATED;
                }
              } 
            }
          });
        }

        fixedAssignedComponents = employeeComponents.map((component) => {
          const compObj = {
            componentId: component.id,
            type: component.componentType,
            name: component.componentName,
            amount: params[component.id]["amount"],
            subType: component.subType,
            status: component.status ? component.status : CONSTANTS.ADDED,
            frequency: component.frequency,
            includeInOTCalc: component.includeInOTCalc,
            isFormula: params[component.id]?.component?.isFormula,
            formula: params[component.id]?.component?.formula,
            formulaConfig: params[component.id]?.component?.formulaConfig
          };
          let object = deepClone(compObj);
          object["frequency"]["period"] = getFrequencyId(
            params[component.id]["frequency"]
          );
          object["status"] = isAlreadyAssignedComponent(component)
            ? CONSTANTS.UPDATED
            : CONSTANTS.ADDED;

          return object;
        });
      }
    }

    //Add Variable Component
    let variableAssignedComponents = [];
    if (variableComponents.length > 0) {
      if (isEditState) {
        const employeeComponents = [...variableComponents];
        if (
          employeeRecord["components"] &&
          employeeRecord["components"].length > 0
        ) {
          employeeRecord["components"].forEach((previousComponent) => {
            let filteredComponent = totalComponent.components.find(
              (x) => x.id === previousComponent.componentId
            );
            if (filteredComponent && filteredComponent.isVariable) {
              let currentComponent = employeeComponents.find(
                (assignedComponent) =>
                  assignedComponent["id"] === previousComponent["componentId"]
              );
              // if (currentComponent && currentComponent.isVariable) {
              if (currentComponent) {
                if (
                  params[currentComponent.id]["amount"] !==
                  previousComponent["amount"]
                ) {
                  currentComponent["status"] = CONSTANTS.UPDATED;
                } else {
                  currentComponent["status"] = CONSTANTS.UPDATED;
                }
              } 
            }
          });
        }
        variableAssignedComponents = employeeComponents.map((component) => {
          let compObj = {
            componentId: component.id,
            type: component.componentType,
            name: component.componentName,
            amount: params[component.id]["amount"],
            subType: component.subType,
            status: component.status ? component.status : CONSTANTS.ADDED,
            frequency: component.frequency,
          };
          let object = deepClone(compObj);
          let componentDetails = deepClone(component);
          object["frequency"]["period"] = getFrequencyId(
            params[component.id]["frequency"]
          );
          if (isInCompliance(COUNTRY_CODE.INDIA) && component.componentConfig) {
            switch (componentDetails.componentConfig.configureAmountBasis) {
              case "percentageOfBasicSalary":
                componentDetails.componentConfig["componentPercent"] =
                  parseFloat(params[component.id]["variableValue"]);
                break;
              case "percentageOfSpecificComponent":
                componentDetails.componentConfig["componentPercent"] =
                  parseFloat(params[component.id]["variableValue"]);
                break;
              case "amountPerDay":
                componentDetails.componentConfig["amountPerDay"] = parseFloat(
                  params[component.id]["variableValue"]
                );
                break;
              case "percentageOfCTC":
                componentDetails.componentConfig["componentPercent"] =
                  parseFloat(params[component.id]["variableValue"]);
                break;
            }
            object["componentConfig"] = componentDetails.componentConfig;
          }
          object["status"] = isAlreadyAssignedComponent(component)
            ? CONSTANTS.UPDATED
            : CONSTANTS.ADDED;
          return object;
        });
      }
    }

    
    if(employeeRecord["components"] &&
    employeeRecord["components"].length > 0) {
      var fixedVarComp = fixedComponents.concat(variableComponents)

      employeeRecord["components"].forEach((comp) => {
        let filteredComponent = fixedVarComp.findIndex(
          (x) => x.id === comp.componentId
        );
        if(filteredComponent == -1) {
          comp["status"] = CONSTANTS.DELETED;
          deletedComponents.push(comp);
        }
      })
    }


    let deletedPreviousComponents = [];
    deletedPreviousComponents = deletedComponents.map((component) => {
      const compObj = {
        componentId: component.componentId,
        type: component.type,
        name: component.name,
        amount: component.amount,
        status: component.status ? component.status : CONSTANTS.ADDED,
        frequency: component.frequency,
      };
      let config = component.isVariable ? compObj['componentConfig'] = component["component"] : "";
      return compObj;
    });
    const salaryAdvanceFields = columnConfig["salaryAdvanceFields"];
    const isSalaryAdvanceEnabled = columnConfig["isSalaryAdvance"];
    if (true) {
      if (isSalaryAdvanceEnabled) {
        const isSalaryAdvance = isSalaryAdvanceEnabled;
        let installments = 0;
        if (
          params["installmentAmount"] &&
          params["installmentAmount"] != "" &&
          params["amount"] &&
          params["amount"] != "" &&
          params["installmentAmount"] != 0
        ) {
          installments = getNoOfInstallment(params);
        }
        let salaryAdvance = {
          amount: parseFloat(params["amount"],10),
          disbursementDate: convertDateToJson(params["disbursementDate"]),
          repaymentStartDate: convertDateToJson(params["repaymentStartDate"]),
          installmentAmount: parseFloat(params["installmentAmount"],10) ,
          noOfInstallments: installments,
          status: isEdit && employeeDetails.user.hasSalaryAdvance
              ? CONSTANTS.UPDATED
              : CONSTANTS.ADDED,
          id: employeeDetails.user && employeeDetails.user.salaryAdvance &&
            employeeDetails.user.salaryAdvance.id
              ? employeeDetails.user.salaryAdvance.id
              : "",
        };
        componentDetailsDataObject["salaryAdvance"] = salaryAdvance;
      }
      if (
        isEdit &&
        !isSalaryAdvanceEnabled &&
        employeeDetails.user &&
        employeeDetails.user.salaryAdvance &&
        !employeeDetails.user.isFinished &&
        !employeeDetails.user.salaryAdvance.isAmountDisbursed
      ) {
        let salaryAdvance = {
          amount: employeeDetails.user.salaryAdvance.amount,
          disbursementDate: employeeDetails.user.salaryAdvance.disbursementDate,
          repaymentStartDate: employeeDetails.user.salaryAdvance.repaymentStartDate,
          installmentAmount: employeeDetails.user.salaryAdvance.installmentAmount,
          noOfInstallments: employeeDetails.user.salaryAdvance.noOfInstallments,
          status: !isSalaryAdvanceEnabled
            ? CONSTANTS.DELETED
            : CONSTANTS.UPDATED,
          id:
            employeeDetails.user.salaryAdvance && employeeDetails.user.salaryAdvance.id
              ? employeeDetails.user.salaryAdvance.id
              : "",
        };
        componentDetailsDataObject["salaryAdvance"] = salaryAdvance;
      }
      componentDetailsDataObject["hasSalaryAdvance"] = isSalaryAdvanceEnabled;
    }
    componentDetailsDataObject['componentGroup'] = (componentGroup && componentGroup.id ? componentGroup.id : '')
    componentDetailsDataObject["components"] = [
      ...fixedAssignedComponents,
      ...variableAssignedComponents,
      ...deletedComponents,
    ];

    return componentDetailsDataObject;

  };

  const getBenefitsDetailsDataObject = () => {
    const params = requiredParams["defaults"];
    const columnConfig = requiredParams["columnConfig"];
    const benefitComponents = columnConfig["benefitComponents"];
    const benefitsDetails = [];
    benefitComponents && benefitComponents.forEach(element => {
      let selectedBenefit =
        totalBenefits &&
        totalBenefits.benefits &&
        totalBenefits.benefits.find((x) => x.benefitId === element.id);
        let benefitObject = getBenefitObject(selectedBenefit, params);
        benefitsDetails.push(benefitObject)
    });
    return benefitsDetails;
  }

  const getBenefitObject = (benefit, params) => {
    let object = {
      annualMaxContribution: benefit.annualMaxContribution,
      benefitId: benefit.benefitId,
      employeeDeductionAmount: params[benefit.benefitId].employeeDeductionAmount,
      employeeDeductionType: benefit.employeeDeductionType,
      employerDeductionAmount: params[benefit.benefitId].employerDeductionAmount,
      employerDeductionType: benefit.employerDeductionType,
      isActive: benefit.isActive,
      name: benefit.name,
      type: benefit.type,
    };
    return object;
  };

  const getNoOfInstallment = (params) => {
      let installments = 0;
      let isRemainValue = 0
      let baseAdvance = params["advanceDetail"] && params["advanceDetail"].isInstallmentInit
        ? params["advanceDetail"].remainingInstallmentAmount
        : params["amount"];
      if(baseAdvance != 0) {
          isRemainValue = ((baseAdvance ) % (params["installmentAmount"]));
          installments = baseAdvance/params["installmentAmount"];
      }
      if(isRemainValue !=0) {
        installments = Math.floor(installments) + 1;
      }
      return installments
    }

  const isAlreadyAssignedComponent = (selectedComponent) => {
    let index = -1;
    if (
      isEditState &&
      employeeResponse["components"] &&
      employeeResponse["components"].length > 0
    ) {
      index = employeeResponse["components"].findIndex(
        (c) => c.componentId === selectedComponent.id
      );
    }

    return index !== -1;
  };

  const getFrequencyId = (frequency) => {
    let value = "";
    let frequencyList = COMPONENT_FREQUENCY_TYPE_LIST.filter(
      (x) => x.name === frequency
    );
    if (frequencyList && frequencyList.length > 0) {
      value = frequencyList[0].id;
    }
    return value;
  };

  const getCustomFieldValues = (params) => {
    let customData = [];
    let filteredCustomFields = (customFields && customFields.customFields) ? customFields.customFields : []
    filteredCustomFields = filteredCustomFields.filter(field=> field.isActive)
    filteredCustomFields.forEach((element) => {
        let field = {};
        field["customFieldId"] = element.id;
        field["value"] = params[element.id]
          ? getValuesOfCustomField(params, element)
          : [];
        field["module"] = "employee_details";
        if (isEditState) {
          const fieldsData =
            employeeDetails &&
            employeeDetails.user &&
            employeeDetails.user.customFieldData
              ? employeeDetails.user.customFieldData
              : [];
          let selectedCustomField = fieldsData.filter(
            (x) => x.customFieldId === element.id
          );
          if (selectedCustomField && selectedCustomField.length > 0) {
            field["id"] = selectedCustomField[0].id;
          }
        }
        customData.push(field);
      });
    return customData;
  };

  const getValuesOfCustomField = (parameter, data) => {
    let values = [];
    if (INPUT_FIELD_MAP[data.type] === INPUT_TYPE.MULTI_SELECT) {
      values = parameter[data.id].map((r) => data.possibleValues[r]);
    } else if (INPUT_FIELD_MAP[data.type] === INPUT_TYPE.DATE) {
      let item = convertDateToJson(parameter[data.id]);
      values.push(item);
    } else {
      let item = parameter[data.id];
      values.push(item);
    }
    return values;
  };

  const getSelectedIdFromDropDown = (value, options, key) => {
    let selectedId = "";
    if (value && Array.isArray(value)) {
      value.forEach((element) => {
        let dropdownValues = options[element];
        if (dropdownValues && dropdownValues[key]) {
          selectedId = dropdownValues[key];
        }
      });
    }
    return selectedId;
  };

  const getValueFromTenant = (key) => {
    let value = "";
    if (tenantData && tenantData.tenant && tenantData.tenant[key]) {
      value = tenantData.tenant[key];
    }
    return value;
  };

  const getLocationValueFromTenantDetails = () => {
    const tenantDetails = TenantManager.getTenantDetails();
    const additionalSettings = tenantDetails
      ? tenantDetails.additionalSettings
      : "";
    const locationSettings = additionalSettings
      ? additionalSettings?.["LOCATION"]
      : {};
    const isLocationActive = locationSettings?.trackLocation || false;
    const locationLabel = isLocationActive ? locationSettings?.locationLabel : "";
    return isLocationActive;
  };

  const prepareDataForCompliance = () => {
    const params = requiredParams["defaults"];
    if(params['socialSecurityNumber']) {
      let sociNo = params['socialSecurityNumber'];
      sociNo = sociNo.replaceAll('-','')
      params['socialSecurityNumber'] = sociNo;
    }
    let complianceDetailsDataObject;
    switch(getTenantCountryCode()) {
      case "MY":
        complianceDetailsDataObject = {
          "@type": "type.googleapis.com/v1.MYCompliance",
        };
        break;
      case COUNTRY.IN:
        complianceDetailsDataObject = {
          "@type": "type.googleapis.com/v1.INCompliance",
        };
        break;
      case COUNTRY.US:
        complianceDetailsDataObject = {
          "@type": "type.googleapis.com/v1.USCompliance",
        };
        break;
      case COUNTRY.SG:
        complianceDetailsDataObject = {
          "@type": "type.googleapis.com/v1.SGCompliance",
        };
        break;
    }
    
    employeeMeta["sections"]?.forEach((fieldSet) => {
      if (fieldSet && fieldSet.fields && fieldSet.fields.length > 0) {
        fieldSet.fields.forEach((field) => {
          /**Committing but will be used for other complainces */
          // if (!field.hidden) {
            if (field.fieldType === "autocomplete") {
              complianceDetailsDataObject[field.fieldId] = params[field.fieldId]
                ? params[field.fieldId]["id"]
                : "";
            } else if (field.fieldType === "checkbox") {
              complianceDetailsDataObject[field.fieldId] =
                params[field.fieldId] ? params[field.fieldId] : false;
            } else if (field.fieldType === INPUT_TYPE.NUMBER) {
              let inputAmount = params[field.fieldId];
              if (typeof inputAmount === CONSTANTS.STRING) {
                complianceDetailsDataObject[field.fieldId] =
                  params[field.fieldId] ? parseFloat(params[field.fieldId]) : 0;
              } else {
                complianceDetailsDataObject[field.fieldId] =
                  params[field.fieldId];
              }
            } else if (field.fieldType === "radioGroup") {
              complianceDetailsDataObject[field.fieldId] =
                params[field.fieldId];
            } else if (INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] === INPUT_TYPE.DROPDOWN) {
              complianceDetailsDataObject[field.fieldId] = params[field.fieldId] ? params[field.fieldId]["id"] : "";
            } else if(INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] === INPUT_TYPE.MULTI_SELECT) {
              complianceDetailsDataObject[field.fieldId] = params[field.fieldId] ? EmployeeListService.getValueForMultiSelect(params[field.fieldId], field.options,"id") : "";
            } else if (
              INPUT_FIELD_MAP_COMPLIANCE[field.fieldType] ===
              INPUT_TYPE.DATE
            ) {
              complianceDetailsDataObject[field.fieldId] = params[field.fieldId]
                ? convertDateToJson(params[field.fieldId])
                : new Date();
            } else if(field.fieldType === "toggleButton") {
                complianceDetailsDataObject[field.fieldId] = getRadioButtonValue(params[field.fieldId]);
            } else {
              complianceDetailsDataObject[field.fieldId] =
                params[field.fieldId];
            }
        });
      }
    });
    return complianceDetailsDataObject;
  };

  const getRadioButtonValue = (value) => {
    if(typeof(value) === "boolean") {
        return value
    }
    if(typeof(value) === "string") {
        return value === "true";
    }
  }

  const handleStepData = (data, callback) => {
    setRequiredProps({ ...data }, callback);
    latestRequiredParams.current = { ...data };
  };

  const saveEmployeeData = (params, expectedStep) => {
    showLoader(isEditState ? "Updating User...Please wait" : "Adding User...Please wait");
    (!isEditState
      ? Table.saveEmployee(params)
      : Table.updateEmployee(params)
    ).then(
      async (response) => {
            removeLoader();
            if (response?.status === 'OK') {
                if (response && response.user) {
                    
                    let userId = response.user.userId ? response.user.userId : "";
                    setUserId(userId);
                    setEditState(true);
                    setUserDataUpdated(false);
                    if (EmployeeListService.employeeStepperCurrentStep === 3) {
                      setSelectedEmployeeData({
                        ...employeeResponse,
                        documents: response?.user?.documents || []
                      });
                    } else {
                      setSelectedEmployeeData(response.user);
                      updateEmployeeRecord(response);
                    }
                }
                if (expectedStep != steps.length) {
                    setCurrentStep(expectedStep);
                    EmployeeListService.employeeStepperCurrentStep = expectedStep;
                } else {
                    EmployeeListService.employeeStepperCurrentStep = 0;
                }
                showToast(`${isEditState ? "Employee Updated" : "Employee Added"} Successfully`, TOAST_TYPE.SUCCESS);
                if(currentStep == 0) {
                  TenantService.getUserData();
                  if(!isEditState) {
                    loadEmployee({
                      customJson:{
                          "orderBy.field": "updatedAt",
                          "orderBy.order": "desc",
                        }
                  });
                  }
                }

                if (currentStep == 0 && TenantService.get(TENANT.USER_ID) === response.user.userId) {
                    const designation = deepClone(response.user.designation);
                    setTimeout(() => {
                        TenantService.set(TENANT.DESIGNATION, designation);
                    },1000);
                    
                }
            } else if (response?.status === 'FAILED') {
                if (!Utility.isEmpty(response['errors']) && (response['errors'][0]['code'] === 'UM_1002' || response['errors'][0]['code'] === 'UM_1003')) {
                    showUserLimitExceedsAlert();
                } else {
                    showToast("Some Unknown Error Occurred at Server. Please Try Again!", TOAST_TYPE.FAILURE);
                }
            } else if (response?.status === 406 && Array.isArray(response?.errors) && response.errors[0]?.message) {
                showAlert('Error occurred!', response.errors[0].message);
            } else {
                showToast("Some Unknown Error Occurred at Server. Please Try Again!", TOAST_TYPE.FAILURE);
            }
        Store.dispatch(fetchTeams())
      },
      (error) => {
        removeLoader();
        if (error?.code === 403 && error?.errorMessage) {
            showToast(`FORBIDDEN 403, ${error.errorMessage}`, TOAST_TYPE.FAILURE);
        } else if (error?.message === "Employee ID already exist") {
            showToast(error.message, TOAST_TYPE.FAILURE);
            setIsDuplicateEmpId(true);
            childRef.current.hightlightInvalidEmployeeId();
        } else if (error?.code === 2 && error?.message && typeof error.message === 'string') {
          if (error.message.includes("required fields cannot be empty:")) {
            showToast("Please fill all the mandatory details", TOAST_TYPE.FAILURE);
          } else {
            try {
              const errorObject = JSON.parse(error.message);
              if(errorObject && errorObject.code === 402 ) {
                showUserLimitExceedsAlert();
              }
            } catch(err) {
              showToast(error.message, TOAST_TYPE.FAILURE);
            }
          }
        } else if (error?.message || error?.errorMessage) {
            showToast(error.message || error.errorMessage, TOAST_TYPE.FAILURE);
        } else {
            showToast("Some Unknown Error Occurred at Server. Please Try Again!", TOAST_TYPE.FAILURE);
        }
      }
    );
  };



  const getCurrentStepChild = () => {
    const currStep = steps[currentStep];
    return currStep.getChild({
      // payrollId: this.payrollId,
      // state: requiredParams,
      userId: userId,
      setData: handleStepData,
      employeeData: employeeResponse,
      employeeDetailedData: employeeDetails.user ? employeeDetails.user : {},
      reportingManagerOptions: reportingManagerOptions,
      ...props,
      ref:childRef,
      isEdit: isEdit,
      isEditState: isEditState,
      isDuplicateEmpId: isDuplicateEmpId,
      setUserDataUpdated: setUserDataUpdated
    });
  };
  const loadEmployee =  (config) => {
    try {
        EmployeeListService.apiConfig = config;
        dispatch(fetchEmployeeListWithoutFilter());
    } catch (err) {
        console.error('Error loading employees: ', err);
    }
  };

  const showSaveBtn = (currentStep) => {
    if (customFieldSectionEnabled) {
      return PermissionUtils.hasAccess(MODULE.EMPLOYEE, [ACTION.EDIT]) || currentStep === 2;
    }
    return true;
  }
  const saveBtnForPWIsEnable = () => {
    return (
      (employeeDetails?.user?.status === CONSTANTS.ACTIVE ||
        employeeDetails?.user?.isInCompleteProfile) &&
      TenantService.get(TENANT.PROGRESS_EMPLOYEE_PROFILE_SAVE_BTN)
    );
  };

  const getControllers = () => {
    const isFirstStep = currentStep === 0;
    const isLastStep = currentStep === steps.length - 1;
    return (
        <div className={`row parent-width justify-content-start mt-l mb-xl ${isLastStep ? "h-80-p":""}`}
            style={{ width: "70%" }} >
            <DKButton
                title="Cancel"
                className="border-m bg-gray1"
                onClick={() => {
                    clearAutoSaveTimer();
                    navigateTo();
                }}
            />
            {isFirstStep && (
                <>
                    {(!isEditState || employeeDetails?.user?.status === CONSTANTS.DRAFT || saveBtnForPWIsEnable()) && showSaveBtn(currentStep) && <DKButton
                        title="Save"
                        className="border-m ml-r bg-gray1"
                        onClick={(e) => {
                            clearAutoSaveTimer();
                            saveAsDraft();
                        }}
                    />}
                    {showSaveBtn(currentStep) && <DKButton
                        title="Save & Next"
                        className="border-m ml-r bg-button text-white bg-app"
                        onClick={(e) => {
                            clearAutoSaveTimer();
                            onSkipToStep();
                        }}
                    />}
                </>
            )}
            {!isFirstStep && !isLastStep && (
                <>
                    <DKButton
                        title="Back"
                        className="border-m ml-r bg-gray1"
                        onClick={() => onSkipToStep(undefined, undefined, true)}
                    />
                    {showSaveBtn(currentStep) && <DKButton
                        title="Save & Next"
                        className="border-m ml-r bg-button text-white bg-app"
                        onClick={(e) => {
                            onSkipToStep()
                        }}
                    />}
                </>
            )}
            {isLastStep && (
                <>
                    <DKButton
                        title="Back"
                        className="border-m ml-r bg-gray1"
                        onClick={() => onSkipToStep(undefined, undefined, true)}
                    />
                    {<DKButton
                        title="Done"
                        className="border-m ml-r bg-button text-white bg-app"
                        onClick={() => saveAndNavigate()}
                    />}
                </>
            )}
        </div>
    );
  };

  const navigateTo = () => {
    removeEmployeeDetails();
    EmployeeListService.employeeStepperCurrentStep = 0;
    RouteManager.navigateToPage(PAGE_ROUTES.EMPLOYEE_LIST);
  };

  const removeEmployeeDetails = async () => {
    try {
      await dispatch(deleteEmployeeDetails());
    } catch (err) {
      // removeLoader();
      console.error("Error removing Employee Details: ", err);
    }
  };

  const saveAndNavigate = () => {
    if (!showSaveBtn(currentStep)) {
      navigateTo();
      return;
    }

    if (TenantService.get(TENANT.COUNTRY_CODE) === COUNTRY.US && currentStep === 3) {
        saveFormData(currentStep, currentStep + 1);
        navigateTo();
    } else {
        const { requiredProps } = steps[currentStep];
        let isInvalid = requiredProps.some(
          (requiredProp) =>
            requiredParams[requiredProp] &&
            isInvalidRecordPresentInCompliance(requiredParams[requiredProp])
        );
        if (!isInvalid) {
          saveFormData(currentStep, currentStep + 1);
          navigateTo();
          // RouteManager.navigateToPage(PAGE_ROUTES.EMPLOYEE_LIST);
        } else {
          const errorInfo =
            steps[currentStep].reqError ||
            `Some of the employees have incomplete profiles. Please update their profiles to proceed.`;
          showToast(errorInfo, TOAST_TYPE.FAILURE);
        }
    }
  };

  const isInvalidRecordPresentInCompliance = (configs) => {
    let isInvalid = false;
    let columns = configs.compliance;
    if (columns) {
      for (let i = 0; i < columns.length; i++) {
        let columnConfig = columns[i];
        let fields = columnConfig?.fields;
        for (let item = 0; item < fields?.length; item++) {
          let individualColumn = fields[item];
          const params = requiredParams["defaults"];
          if (
            individualColumn &&
            params &&
            (individualColumn.uiVisible && (
              individualColumn.required &&
                Utility.isEmptyForCompliance(params[individualColumn.columnCode])
            ) ||
              individualColumn.hasError)
          ) {
            isInvalid = true;
            childRef.current.hightlightInvalidFieldsInCompliance();
            return isInvalid;
          }
        }
      }
    }

    if (hasInvalidcustomSectionField(configs) && childRef.current.hightlightInvalidFieldsInCompliance) {
      isInvalid = true;
      childRef.current.hightlightInvalidFieldsInCompliance();
    }
   
    return isInvalid;
  };

  const hasInvalidcustomSectionField = (configs) => {
    let customSectionConfig = configs?.customSections;
    if (Array.isArray(customSectionConfig) && employeeDetails?.user?.hideCompensation) {
      customSectionConfig = customSectionConfig.filter((config) => config.name !== CONFIG_SECTION.COMPENSATION)
    }

    return CustomSectionManager.hasInvalidcustomSectionField(customSectionConfig);
  }

  const updateEmployeeRecord = async (response) => {
    try {
      await dispatch(updateEmployeeDetails(response));
    } catch (err) {
      // removeLoader();
      console.error("Error loading Employee Details: ", err);
    }
  };

  const getHeaderName = () => {
      let employeeName = "Add Employee";
      if(isEdit) {
          const firstName = employeeDetails?.user?.firstName || CONSTANTS.EMPTY_STRING ;
          const lastName = employeeDetails?.user?.lastName || CONSTANTS.EMPTY_STRING;
          employeeName = `${firstName} ${lastName}`;
      }
      return employeeName;
  }

  return (
    <>
      {steps && steps.length > 0 && (
        <>
        <div className="mb-xl fw-m fs-l">
            {getHeaderName()}
        </div>
        <div className="column parent-width ">
          <Stepper
            data={steps}
            currentIndex={currentStep}
            className="mb-l"
            stepperType="EMPLOYEE_DEATILS"
            width={stepperWidth}
            currentStep={currentStep}
            employeeDetails={employeeDetails?.user}
          />
          <div className="m-v-xl row parent-width justify-content-start margin-empty-mobile">
            <div className="parent-width">{getCurrentStepChild()}</div>
          </div>
          {getControllers()}
        </div>
        </>
      )}
    </>
  );
};

export default AddEmployeePortal;
